/**
 * 파일 타입별 이미지 경로 상수
 */
export const FILE_TYPE_IMAGES = {
  pdf: '/assets/build/pdf.png',
  docx: '/assets/build/docx.png',
  doc: '/assets/build/docx.png', // DOCX와 동일한 아이콘 사용
  pptx: '/assets/build/pptx.png',
  ppt: '/assets/build/pptx.png', // PPTX와 동일한 아이콘 사용
  hwp: '/assets/build/hwp.png',
  txt: '/assets/build/txt.png',
  csv: '/assets/build/csv.png',
} as const;

/**
 * 파일명에서 확장자를 추출합니다
 */
export function getFileExtension(filename: string): string {
  const parts = filename.split('.');
  return parts.length > 1 ? parts.at(-1)!.toLowerCase() : '';
}

/**
 * 파일 확장자에 해당하는 이미지 경로를 반환합니다
 */
export function getFileTypeImage(filename: string): string | null {
  const extension = getFileExtension(filename);
  return FILE_TYPE_IMAGES[extension as keyof typeof FILE_TYPE_IMAGES] || null;
}
